/* eslint "global-require":"off" */ import plugin from "tailwindcss/plugin";
import variablesPlugin from "@mertasan/tailwindcss-variables";
import gridAreaPlugin from "@savvywombat/tailwindcss-grid-areas";
import { colors, colorVariables } from "./colors";
import { fontFamily } from "./fontFamily";
import { fontWeight } from "./fontWeight";
import { fontSize, fontSizeMap } from "./fontSize";
import { lineHeight } from "./lineHeight";
import { spacing } from "./spacing";
import { maxWidth } from "./maxWidth";
export var config = {
    content: [
        "**/*.tsx"
    ],
    darkMode: "class",
    theme: {
        extend: {
            spacing: spacing,
            maxWidth: maxWidth,
            gridTemplateAreas: {
                "footer\\/md": [
                    "logo logo info info info info",
                    "content content info info info info",
                    "social social info info info info",
                    "legal legal legal legal legal legal"
                ],
                "footer\\/sm": [
                    "logo content",
                    "info info",
                    "social social",
                    "legal legal"
                ]
            },
            gridTemplateColumns: {
                "footer\\/sm": "repeat(2, minmax(0, 1fr))",
                "footer\\/md": "repeat(6, minmax(0, 1fr))"
            }
        },
        colors: colors,
        fontSize: fontSize,
        fontFamily: fontFamily,
        fontWeight: fontWeight,
        lineHeight: lineHeight,
        container: {
            center: true,
            padding: spacing["6"],
            screens: {}
        },
        typography: {
            DEFAULT: {
                css: {
                    "h1,h2,h3": {
                        "margin-bottom": "0.5em"
                    },
                    "h4,h5,h6,p": {
                        "margin-bottom": "1em"
                    },
                    "h1,h2,h3,h4,h5,h6": {
                        "font-weight": fontWeight.medium
                    },
                    h1: {
                        "font-size": fontSizeMap.h1.small
                    },
                    h2: {
                        "font-size": fontSizeMap.h2.small
                    },
                    h3: {
                        "font-size": fontSizeMap.h3.small
                    },
                    h4: {
                        "font-size": fontSizeMap.h4.base
                    },
                    h5: {
                        "font-size": fontSizeMap.h5.small
                    },
                    h6: {
                        "font-size": fontSizeMap.h6.small
                    },
                    p: {
                        "font-size": fontSizeMap.body.small,
                        "line-height": "1.5"
                    },
                    "strong, b": {
                        "font-weight": fontWeight.bold
                    },
                    "a:not([class])": {
                        color: "var(--colors-blue-medium)",
                        "text-decoration": "underline"
                    },
                    "a:not([class]):hover": {
                        color: "var(--colors-blue-light)"
                    },
                    "body.dark a:not([class])": {
                        color: "var(--colors-blue-light)"
                    },
                    "body.dark a:not([class]):hover": {
                        color: "var(--colors-blue-medium)"
                    }
                }
            },
            md: {
                css: {
                    h1: {
                        "font-size": fontSizeMap.h1.base
                    },
                    h2: {
                        "font-size": fontSizeMap.h2.base
                    },
                    h3: {
                        "font-size": fontSizeMap.h3.base
                    },
                    h4: {
                        "font-size": fontSizeMap.h4.base
                    },
                    h5: {
                        "font-size": fontSizeMap.h5.base
                    },
                    h6: {
                        "font-size": fontSizeMap.h6.base
                    },
                    p: {
                        "font-size": fontSizeMap.body.base
                    }
                }
            },
            lg: {
                css: {
                    h1: {
                        "font-size": fontSizeMap.h1.base
                    },
                    h2: {
                        "font-size": fontSizeMap.h2.base
                    },
                    h3: {
                        "font-size": fontSizeMap.h3.base
                    },
                    h4: {
                        "font-size": fontSizeMap.h4.base
                    },
                    h5: {
                        "font-size": fontSizeMap.h5.base
                    },
                    h6: {
                        "font-size": fontSizeMap.h6.base
                    },
                    p: {
                        "font-size": fontSizeMap.body.large
                    }
                }
            }
        },
        variables: {
            DEFAULT: {
                colors: colorVariables
            }
        }
    },
    plugins: [
        gridAreaPlugin,
        variablesPlugin({
            colorVariables: true
        }),
        require("@tailwindcss/typography"),
        plugin(function(param) {
            var addUtilities = param.addUtilities, addBase = param.addBase, theme = param.theme;
            addUtilities({
                ".writing-mode-vertical": {
                    "writing-mode": "vertical-lr"
                },
                ".no-drag": {
                    "-webkit-user-drag": "none",
                    "user-drag": "none"
                }
            });
            addBase({
                ".container": {
                    maxWidth: "calc(".concat(theme("maxWidth.md"), " + ").concat(theme("spacing.6"), " * 2)")
                }
            });
        })
    ]
};

//# sourceMappingURL=config.js.map